import { Button } from "@mui/material";
import { string, object, func } from "prop-types";
import React from "react";

type BlackButtonProps = React.ComponentProps<typeof Button>;

export const BlackButton = (props: BlackButtonProps) => {
  const sx = {
    backgroundColor: "common.black",
    color: "common.white",
    borderRadius: 1,
    // py: 1,
    // px: 3,
  };

  return (
    <Button
      {...props}
      sx={{
        ...sx,
        ...props.sx,
      }}
      // onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
};

BlackButton.propTypes = {
  children: string,
  sx: object,
  onClick: func,
};
